import { ClassicPreset, NodeId } from 'rete';
import { ClassicScheme, ReactArea2D, RefComponent } from 'rete-react-plugin';
import { GetSockets, Side } from 'rete-react-plugin/_types/presets/classic/types';
import classNames from 'classnames';

type Props<Scheme extends ClassicScheme> = {
  name: string;
  emit: (props: ReactArea2D<Scheme>) => void;
  side: Side;
  nodeId: NodeId;
  socketKey: string;
  payload: ClassicPreset.Socket;
  disabled?: boolean;
  className?: string;
};

export function RefSocket<Scheme extends ClassicScheme>({
  name,
  emit,
  nodeId,
  side,
  socketKey,
  payload,
  className: classNameProp,
  disabled,
  ...props
}: Props<Scheme>) {
  const className = classNames(name, { 'socket-disabled': disabled }, classNameProp);
  return (
    <RefComponent
      {...props}
      className={className}
      init={(ref) =>
        emit({
          type: 'render',
          data: {
            type: 'socket',
            side,
            key: socketKey,
            nodeId,
            element: ref,
            payload: payload as GetSockets<Scheme['Node']>,
          },
        })
      }
      unmount={(ref) => emit({ type: 'unmount', data: { element: ref } })}
    />
  );
}
